import { Table, Modal, Tag, Button, Checkbox, Select } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal) <{ color?: string }>`
  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: ${props => props.color};
    height: 61px;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    padding: 0;
    max-height: calc(90vh - 140px);
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-modal-footer {
    border-top: 1px solid #e0e0e0;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    height: 200px !important;
    word-break: break-all;
  }
`;

export const ColumnTitle = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  margin-top: 32px;

  p {
    width: 100px;
    transform: rotate(-90deg);
  }
`;

export const StyledTag = styled(Tag)`
  border-radius: 10px;
`;

export const ButtonStyled = styled(Button) <{ color?: string }>`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: ${props => props.color};
  border: none;

  &:hover, &:active, &:focus {
    opacity: 0.8;
    background-color: ${props => props.color};
  }
`;

export const ButtonStyledLink = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;

  &:hover, &:active, &:focus {
    color: #666;
    border: 1px solid #ddd;
    background-color: #e9ecef !important;
  }
`;

export const ContentButton = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledCheckbox = styled(Checkbox)`
  font-size: 13px;
  color: #333;
  font-weight: 500;
`;

export const MatrizScrollContainer = styled.div`
  display: block;
  max-height: 500px;
  min-height: 0;
  overflow: auto;
  position: relative;
  width: 100%;

  &::-webkit-scrollbar:vertical {
    width: 0;
  }

  &::-webkit-scrollbar:horizontal {
    height: 8px;
  }
`;

export const MatrizTable = styled.table`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: auto;
  border-collapse: separate;
  table-layout: fixed;
  position: relative;
  max-width: 100%;
  width: 100%;

  tbody td {
    width: 150px;
  }

  thead th {
    width: 150px;
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: #f8f9fa;

    tr {
      display: table-row;
    }
  }
`;

export const TableHeaderCell = styled.th`
  min-width: 100px;
  max-width: 100px;
  width: 60px;
  padding: 12px 8px;
  text-align: center;
  font-weight: 600;
  color: #333;
  border: 1px solid #e0e0e0;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 150;
  background: #f8f9fa !important;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
`;

export const OperationHeader = styled.th`
  transition: background 0.2s;
  white-space: nowrap;
  min-width: 45px;
  width: 45px;
  height: 70px;
  font-size: 11px;
  vertical-align: bottom;
  background: #f8f9fa !important;
  padding: 12px 8px;
  text-align: center;
  font-weight: 600;
  color: #333;
  border: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const OperationHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  height: 100%;
  justify-content: space-between;
  padding-top: 5px;
`;

export const OperationHeaderTitle = styled.div`
  font-weight: 600;
  font-size: 11px;
  color: #333;
  white-space: nowrap;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SelectAllColumnBtn = styled.button`
  background-color: #f8f9fa;
  color: #666;
  border: 1px solid #e0e0e0;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  gap: 3px;
  transition: all 0.2s;
`;

export const TableBodyCell = styled.td`
  background-color: #fff;
  font-weight: 600;
  min-width: 100px;
  max-width: 100px;
  width: 100px;

  padding: 8px;
  text-align: center;
  border: 1px solid #e0e0e0;
  vertical-align: middle;

  div &:nth-child(1) {
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 2px;
  }

  div &:nth-child(2) {
    font-size: 10px;
    color: #888;
  }
`;

export const OperationCell = styled.td`
  padding: 8px;
  text-align: center;
  border: 1px solid #e0e0e0;
  vertical-align: middle;
`;

export const OperationCard = styled.label<{ completed?: boolean }>`
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 4px;
  transition: all 0.2s;
  position: relative;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-color: #e0e0e0;
  background: white;
  opacity: 0.7;

  ${props => props.completed && `
    border-color: #e0e0e0;
    background: white;
    opacity: 0.7;
    cursor: not-allowed;
  `}

  &:has(input[type="checkbox"]:checked) {
    border-color: #4caf50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.3);
  }
`;

export const OperationCardInputCheck = styled(Checkbox)`
  position: absolute;
  top: 4px;
  right: 4px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const OperationCardSequence = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #333;
`;

export const OperationCardDate = styled.div`
  font-size: 10px;
  color: #666;
  font-weight: 500;
`;

export const OperationCardStatus = styled.div<{ backgroundColor?: string }>`
  font-size: 10px;
  padding: 3px 7px;
  border-radius: 12px;
  font-weight: 600;
  border: none;
  color: #fff;
  background-color: ${(props) => props.backgroundColor};
`;

export const EmptyCell = styled.div`
  background-color: #fafafa;
  color: #ccc;
  font-size: 12px;
  font-style: italic;
`;

export const SelectCompact = styled.div`
  select {
    padding: 6px 12px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fff;
  }
`;

export const Warning = styled.div`
  color: #1976d2;
  background-color: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StyledSelect = styled(Select) <{ borderColor?: string }>`
  width: 100%;
  
  .ant-select-selector {
    border-radius: 10px !important;
    border-color: ${({ borderColor }) => borderColor} !important;
  }
`;

export const AcoesHeader = styled.div`
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin: 16px;

  p {
    color: #424242;
    font-weight: bold;
    margin-bottom: 8px;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    p {
      background-color: #2196f3;
      color: #fff;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 500;
    }
  }
`;

export const AcoesTable = styled.div`
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin: 16px;

  p {
    color: #424242;
    font-weight: bold;
    margin-bottom: 8px;
  }
`;
